import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { MessageCircle, Save, Loader2 } from "lucide-react";

const PURPLE = "#2B1E4A";
const MAGENTA = "#B5179E";
const GOLD = "#F5B400";

const TOGGLES = [
  ["send_out_for_delivery", "Aviso de saída para entrega", "Avisa a cliente quando o pedido sai"],
  ["send_otp", "Enviar código OTP", "Envia o código de recebimento por WhatsApp"],
  ["allow_resend", "Permitir reenvio de OTP", "Entregador/admin pode reenviar o código"],
  ["send_delivered", "Confirmação de entrega", "Avisa a cliente quando a entrega é concluída"],
];

export default function LogisticaWhatsAppConfig() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/deliveries/wa/config").then(({ data }) => setCfg(data)).catch(() => toast.error("Erro ao carregar"));
  useEffect(() => { load(); }, []);
  const set = (k, v) => setCfg({ ...cfg, [k]: v });

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/deliveries/wa/config", cfg);
      setCfg(data); toast.success("Configuração salva");
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
    finally { setSaving(false); }
  };

  if (!cfg) return <div className="p-8 text-center text-sm text-[#9A8A98]">Carregando...</div>;

  return (
    <div className="mx-auto max-w-2xl space-y-5 p-4 lg:p-8" data-testid="wa-config-page">
      <div className="flex flex-wrap items-center gap-3 rounded-2xl p-5 text-white" style={{ background: `linear-gradient(135deg, ${PURPLE}, ${MAGENTA})` }}>
        <span className="grid h-11 w-11 place-items-center rounded-xl" style={{ background: GOLD }}><MessageCircle size={22} className="text-[#2B1E4A]" /></span>
        <div className="flex-1"><div className="text-[11px] font-bold uppercase tracking-[0.25em]" style={{ color: GOLD }}>CRIS ROTA · Configurações</div><h1 className="font-display text-lg font-bold">WhatsApp de Entrega</h1></div>
      </div>

      <div className="space-y-1 rounded-2xl border border-border bg-white p-3">
        {TOGGLES.map(([k, label, hint]) => (
          <label key={k} className="flex items-center justify-between gap-3 rounded-xl px-2 py-3">
            <span><span className="block text-sm font-bold text-brand-dark">{label}</span><span className="block text-[12px] text-[#8A7788]">{hint}</span></span>
            <input type="checkbox" checked={!!cfg[k]} onChange={(e) => set(k, e.target.checked)} className="h-5 w-5 shrink-0" data-testid={`wa-${k}`} />
          </label>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3 rounded-2xl border border-border bg-white p-5">
        <div>
          <label className="mb-1 block text-[12px] font-bold text-[#6B5A69]">Throttle de reenvio (segundos)</label>
          <input type="number" min="0" value={cfg.resend_throttle_seconds} onChange={(e) => set("resend_throttle_seconds", Number(e.target.value))} className="w-full rounded-xl border border-border px-3 py-2 text-sm" data-testid="wa-throttle" />
        </div>
        <div>
          <label className="mb-1 block text-[12px] font-bold text-[#6B5A69]">Máximo de reenvios</label>
          <input type="number" min="0" value={cfg.resend_max} onChange={(e) => set("resend_max", Number(e.target.value))} className="w-full rounded-xl border border-border px-3 py-2 text-sm" data-testid="wa-max" />
        </div>
      </div>

      <button onClick={save} disabled={saving} className="flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-bold text-white disabled:opacity-50" style={{ background: PURPLE }} data-testid="wa-save-btn">{saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Salvar</button>
    </div>
  );
}
